import { render } from "./BlockKuzusi.vue?vue&type=template&id=3fba7824"
import script from "./BlockKuzusi.vue?vue&type=script&lang=js"
export * from "./BlockKuzusi.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__